import format from "date-fns/format";
import isValid from "date-fns/isValid";

import { isoToDate } from "./isoToDate";

// Compact "M/D/YY" date (e.g. 9/3/26). Accepts a Date or an ISO/loose string.
export const formatDateShortYy = (d, fallback = "—") => {
  const dt = d instanceof Date ? d : isoToDate(d);
  if (!dt || !isValid(dt)) return fallback;
  return format(dt, "M/d/yy");
};

export default formatDateShortYy;
